import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { BtnGroupStyle, ContentStyle, DataGridListStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import { useDispatch, useSelector } from "react-redux";
import { loadingAllSavedPrescriptions } from "../../Redux/Slice/AllSavedPrescriptionsSlice";
import { v4 as uuid } from "uuid";
import {
  ConfirmSavedPrescriptions,
  PatientDetailsOfLeftcard,
  RemoveAllSavedPrescriptionsById,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import ConfirmPopup from "../../components/ConfirmPopup";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import NoRecords from "../../components/NoRecords";
import {
  DrugTextNTooltip,
  PharmacyTextNTooltip,
  TextClick,
  TextNTooltip,
} from "../../components/Content";
import ErrorOverlay from "../../components/ErrorOverlay";
import useFetch from "../../CustomHooks/useFetch";

export default function AllSavedPrescriptions() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectionData, setSelectionData] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);
  const [selectionContent, setSelectionContent] = useState<any>([]);
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };

  const [patientDetailsPopUp, setPatientDetailsPopUp] = useState(false);

  const handleShowDetailsPopupClick = () => {
    setPatientDetailsPopUp(true);
  };
  const handleHideDetailsPopupClick = () => {
    setPatientDetailsPopUp(false);
  };

  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("savedPrescriptionIds", selectionData);
      const result = await RemoveAllSavedPrescriptionsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getAllSavedPrescriptions(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const [ptId, setPtId] = useState("");
  const columnsAllSavedPrescriptions: GridColDef[] = [
    {
      field: "description",
      headerName: "Drug Description",
      width: 200,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <DrugTextNTooltip row={row} />,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => (
        <TextClick
          Text={row?.patientFirstName + " " + row?.patientLastName}
          onClick={() => {
            setPtId(row?.personId);
            handleShowDetailsPopupClick();
          }}
        />
      ),
    },
    {
      field: "personId",
      headerName: "Patient Id",
      width: 110,
      cellClassName: "w20 patientId",
      headerClassName: "w20",
      renderCell: ({ row }) => <TextNTooltip Text={row?.personId} />,
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 200,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <PharmacyTextNTooltip row={row} />,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
  ];
  const AllSavedPrescriptionsState = useSelector((state: any) => {
    return { ...state.AllSavedPrescriptionsSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    AllSavedPrescriptionsState?.Pagination?.totalItems || 0
  );
  const [superId, setSuperId] = useState("");
  useEffect(() => {
    const handleStorage = () => {
      const pId: any = localStorage.getItem("SupervisorDoctorId");
      setSuperId(pId);
    };

    window.addEventListener("storage", handleStorage);

    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  const getAllSavedPrescriptions = (nextPage: number) => {
    let bodyData = {
      pageNumber: nextPage,
      pageSize: pageSize,
      doctorId:
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : localStorage.getItem("doctorId"),
    };
    dispatch(loadingAllSavedPrescriptions(bodyData));
  };

  useEffect(() => {
    getAllSavedPrescriptions(page);
  }, [page, superId]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      AllSavedPrescriptionsState?.Pagination?.totalItems !== undefined
        ? AllSavedPrescriptionsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [AllSavedPrescriptionsState?.Pagination?.totalItems, setRowCountState]);
  const [load, setLoad] = useState(false);
  const confirmSavedPrescriptions = async () => {
    try {
      setLoad(true);
      const bodyData = {
        patientId: selectionContent[0]?.personId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
        prescriptionIds: selectionData === "" ? null : selectionData,
      };
      const result: any = await ConfirmSavedPrescriptions(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "patientId",
          result?.data?.response[0]?.prescriptionFormList[0]?.patientId
        );
        navigate("/newrxpad/summary", { state: "confirmAspList" });
        sessionStorage.setItem(
          "locationData",
          JSON.stringify(result?.data?.response[0])
        );
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
        );
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        setLoad(false);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoad(false);
      }
    } catch (er) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again Later!",
          variant: "error",
          open: true,
        };
      });
      setLoad(false);
    }
  };
  if (load)
    return (
      <Grid
        container
        justifyContent={"center"}
        display={"flex"}
        alignItems="center"
        height={"100vh"}
      >
        {" "}
        <CircularProgress color="primary" />
      </Grid>
    );
  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          All Saved Prescriptions
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  Prescriptions that doctors write and save for potential future
                  use, regardless of the patients.
                </Typography>
              </>
            }
          />
        </Typography>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={AllSavedPrescriptionsState?.Items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsAllSavedPrescriptions}
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[pageSize]}
                disableSelectionOnClick
                paginationMode="server"
                checkboxSelection
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={AllSavedPrescriptionsState?.error || undefined}
                getRowId={(row) => row.savePersonPrescriptionId ?? uuid()}
                loading={AllSavedPrescriptionsState?.isLoading}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                  const selectedIDs = new Set(ids);
                  const selectedRows =
                    AllSavedPrescriptionsState?.Items?.filter((row: any) =>
                      selectedIDs.has(row?.savePersonPrescriptionId)
                    );
                  setSelectionContent(selectedRows);
                }}
                getRowClassName={(params) => {
                  if (params.row.obseletRx) {
                    return "OP";
                  }
                  return "";
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={handleShowDeletePopupClick}
                className=""
                children={"Delete"}
                size={"large"}
                type="button"
                color="primary"
                variant="outlined"
              />{" "}
              <YSButton
                onClick={() => {
                  confirmSavedPrescriptions();
                }}
                className=""
                children={"Confirm Prescription(s)"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>

      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={patientDetailsPopUp}
        handleShowPopupClick={handleShowDetailsPopupClick}
        handleHidePopupClick={handleHideDetailsPopupClick}
        close={true}
      >
        <PatientDetails ptId={ptId} />
      </DialogPopup>

      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}

function PatientDetails(prop: any) {
  const { ptId } = prop;
  const Params = {
    patientId: ptId,
  };
  const {
    data: row,
    loading,
    error,
  }: any = useFetch(Params, PatientDetailsOfLeftcard, []);
  if (loading)
    return (
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        height={"50vh"}
      >
        <CircularProgress color="primary" />
      </Grid>
    );

  if (error)
    return (
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        height={"100vh"}
      >
        <Typography color="primary"> Something went wrong!</Typography>
      </Grid>
    );
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.patientName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          DOB:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.dateOfBirth}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Age:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.age}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Gender:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.gender}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.address}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Telephone No:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.homeTelephone}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          PatientID:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row[0]?.hostPatientId}
        </Typography>
      </Grid>
    </Grid>
  );
}
